import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, AlertTitle, Button } from '@mui/material';

/**
 * Where the account's claim stands, said once in the same words wherever it
 * shows: the wizard and the listing it was made on.
 *
 * Nothing for a withdrawn claim — the account took it back and knows — nor
 * for no claim at all.
 */
function ClaimStatus({ claim, onWithdraw, saving = false, sx }) {
  if (!claim) {
    return null;
  }

  const name = claim.provider.name;

  if ('PENDING' === claim.status) {
    return (
      <Alert
        severity="info"
        sx={sx}
        action={
          onWithdraw && (
            <Button color="inherit" size="small" onClick={onWithdraw} disabled={saving}>
              Retirer ma demande
            </Button>
          )
        }
      >
        <AlertTitle>Votre demande pour « {name} » est en cours</AlertTitle>
        Un modérateur vérifie que vous représentez bien cette activité. Vous serez prévenu par
        email de sa décision.
      </Alert>
    );
  }

  if ('REJECTED' === claim.status) {
    return (
      <Alert severity="warning" sx={sx}>
        <AlertTitle>Votre demande pour « {name} » n’a pas été acceptée</AlertTitle>
        {claim.rejection_reason}
      </Alert>
    );
  }

  if ('APPROVED' === claim.status) {
    return (
      <Alert
        severity="success"
        sx={sx}
        action={
          <Button color="inherit" size="small" component={RouterLink} to="/pro/ma-fiche">
            Voir ma fiche
          </Button>
        }
      >
        <AlertTitle>« {name} » est désormais votre fiche</AlertTitle>
        Vous pouvez la compléter et la tenir à jour depuis votre espace.
      </Alert>
    );
  }

  return null;
}

export default ClaimStatus;
